import React, { useEffect, useRef, useState } from "react";
import { Stack, Button, Typography, IconButton, Box, styled } from "@mui/material";
import WaveSurfer from "wavesurfer.js";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { AttachStatusChatText } from "components/typography/text";
import fileDownloader from "services/utils/FileDownloader";
import moment from 'moment-jalaali';

const AtachmentContainer = styled(Stack)(
    ({ theme }) => `
        border-radius: 12px;
        min-width: 50%;
        max-width: 300px;
        border: 1px solid rgba(238, 238, 238, 0.93);
        box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.10);
        padding: ${theme.spacing(0.5)} ${theme.spacing(1)};
        padding-top: ${theme.spacing(1)};
    `
)

const AtachmentLogoBox = styled(Stack)(
    ({ theme }) => `
        border-radius: 8px;
        background: rgba(238, 238, 238, 0.93);   
        width: 100%;
        padding: ${theme.spacing(0.5)} ${theme.spacing(1)};
    `
)

export default function AtachmentChatCard({ data, isMine, seen, trigerToBottom }) {

    const fileFormat = data.Text.split('.').pop();
    
    const downloadAttachedFile = () => {
        fileDownloader(data.Attachment.split('/').pop(), data.Attachment)
    }

    const mainBackColor = isMine ? "#F9F9F9" : "#FFFFFF"

    useEffect(() => {
        if(trigerToBottom) {
            window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        }
    }, [])

    
    const bytesToKB = (bytes) => {
        return (bytes / 1024).toFixed(2);
    }

    const bytesToMB = (bytes) => {
        return (bytes / (1024 * 1024)).toFixed(2);
    }

    return(
        <Stack alignItems={isMine ? "flex-start" : "flex-end"}>
            <AtachmentContainer sx={{background: mainBackColor}} spacing={1}>
                <AtachmentLogoBox onClick={downloadAttachedFile} direction="row" alignItems="center" justifyContent="flex-end" spacing={1}>
                    <Typography noWrap sx={{width: "100%"}}>{data.Text}</Typography>
                    <DescriptionIcon sx={{color: 'white', fontSize: "32px"}} />
                </AtachmentLogoBox>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={0.5}>
                    <Stack direction="row" spacing={0.5}>
                        {
                            isMine && 
                            (
                                seen ?
                                <DoneAllIcon fontSize="14px" color="success" />
                                :
                                <CheckIcon fontSize="14px" color="success" />
                            )
                        }
                    <AttachStatusChatText variant="caption">{moment(data.CreatedDate).format("HH:mm")}</AttachStatusChatText>
                    </Stack>

                    <Stack direction="row" spacing={1} >
                        <AttachStatusChatText>{bytesToKB(data.AttachmentSize) < 1024 ? `${bytesToKB(data.AttachmentSize)}KB` : `${bytesToMB(data.AttachmentSize)}MB` } <span style={{marginLeft: "0.5rem"}} >{fileFormat}</span></AttachStatusChatText>
                        <AttachStatusChatText></AttachStatusChatText>
                    </Stack>
                </Stack>
            </AtachmentContainer>
        </Stack>
    )
}